// Mave-video laadt pas als iemand op "Bekijk de video" tikt: tot die tijd kost
// een video op de pagina niets (alleen de poster als afbeelding).

const MAVE_SCRIPT = 'https://cdn.video-dns.com/npm/@maveio/components@0.0.148/dist/components/clip.js';

let belofte = null;

export function laadMave() {
    if (window.customElements && window.customElements.get('mave-clip')) {
        return Promise.resolve();
    }

    belofte ??= new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.type = 'module';
        script.src = MAVE_SCRIPT;
        script.dataset.mave = '';
        script.onload = resolve;
        script.onerror = () => {
            belofte = null;
            reject(new Error('Mave kon niet geladen worden'));
        };
        document.head.appendChild(script);
    });

    return belofte;
}
